var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_362_5842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 25C5 15.5719 5 10.8579 7.92893 7.92893C10.8579 5 15.5719 5 25 5C34.4281 5 39.1421 5 42.0711 7.92893C45 10.8579 45 15.5719 45 25C45 34.4281 45 39.1421 42.0711 42.0711C39.1421 45 34.4281 45 25 45C15.5719 45 10.8579 45 7.92893 42.0711C5 39.1421 5 34.4281 5 25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2082 22.5C31.9229 22.5613 33.3789 23.8474 33.3321 25.5703C33.3212 25.9711 33.1659 26.4665 32.8553 27.4574C32.108 29.842 30.852 31.912 28.0383 32.4087C27.5211 32.5 26.9391 32.5 25.7751 32.5H24.2246C23.0606 32.5 22.4786 32.5 21.9614 32.4087C19.1477 31.912 17.8917 29.842 17.1443 27.4574C16.8338 26.4665 16.6785 25.9711 16.6676 25.5703C16.6208 23.8474 18.0768 22.5613 19.7915 22.5",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 26.6667V17.5M24.9998 26.6667C24.4163 26.6667 23.3261 25.0047 22.9165 24.5833M24.9998 26.6667C25.5833 26.6667 26.6736 25.0047 27.0832 24.5833",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_362_5842",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.0235294 0 0 0 0 0.0235294 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_362_5842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_362_5842",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.5fca8444d505535c9048727247d7e99d.svg";
export { ForwardRef as ReactComponent };